import { Injectable, Type } from "@angular/core";
import { Routes } from "@angular/router";
import { DynamicRoute, IDynamicRoutesProvider } from "core";
import { DASHBOARD_DESCRIBE } from "../constants";
import { Dashboard } from "../dashboard/dashboard";

@Injectable({ providedIn: 'root' })
export class DashboardRoutesProvider extends IDynamicRoutesProvider {

    override componentMap: Record<string, Type<any>> = {
        'dashboard': Dashboard,
    };

    // deve corrispondere all'id nel json della chiamate delle rotte
    override describe(): String {
        return 'dashboard';
    }

    override evaluate(dynamicRoute: DynamicRoute[]): Routes {
        return this.buildRoutes(dynamicRoute, DASHBOARD_DESCRIBE);
    }
}